import React, { useEffect, useState } from "react"
import CommonModal from "components/CommonModal"
import { Box, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { getAvailableParticipantsAction } from "redux/DMV/actions/user"
// import MultipleSelect from "components/StyledComponents/MultipleSelect"
import AppButton from "components/StyledComponents/AppButton"
import AppSelect from "components/StyledComponents/AppSelect"

const ActionButtons = ({ onSubmit, onClose }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", gap: 2, pb: 2 }}>
      <AppButton onClick={onClose}>Cancel</AppButton>
      <AppButton onClick={onSubmit}>Add Participant</AppButton>
    </Box>
  )
}

const AddParticipantModal = ({ open, onClose, onSubmit }) => {
  const [selectedParticipants, setSelectedParticipants] = useState([])
  const dispatch = useDispatch()
  const { leagueId, availableParticipants } = useSelector((state) => state.dmv?.league)

  useEffect(() => {
    if (open) {
      dispatch(
        getAvailableParticipantsAction({
          leagueId: leagueId
        })
      )
      setSelectedParticipants([])
    }
  }, [open])

  const handleParticipantSelection = (e) => {
    setSelectedParticipants(e.target.value)
  }

  return (
    <CommonModal
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      actionButtons={
        <ActionButtons onSubmit={() => onSubmit(selectedParticipants)} onClose={onClose} />
      }
      maxWidth="sm">
      <Box className="p-4 d-flex flex-column gap-4 justify-content-center align-items-center">
        <Typography variant="h2">Add Participant</Typography>

        <AppSelect
          menuItems={availableParticipants}
          value={selectedParticipants}
          onChange={handleParticipantSelection}
          label="Available Participants"
          placeholder="Select Participant"
          isRequired={true}
        />
      </Box>
    </CommonModal>
  )
}

export default AddParticipantModal
